export default {
  mounted() {
    const element = this.el
    const fullText = element.innerHTML
    const { msBeforeNextCharacter, min, max } = getSpeedConfig(this.el.dataset.speed ?? 'default')
    let index = 0
    let currentText = '' // Initialize an empty string to accumulate the text

    const typeCharacter = () => {
      if (index < fullText.length) {
        const chunkSize = Math.floor(Math.random() * (max - min + 1)) + min // Generate random number between 2 and 10
        const nextIndex = Math.min(index + chunkSize, fullText.length)

        currentText += fullText.substring(index, nextIndex) // Add the next chunk of text to the current text
        element.innerHTML = currentText // Update the element's content with the accumulated text

        index = nextIndex // Update the index for the next iteration
        setTimeout(typeCharacter, msBeforeNextCharacter)
      }
    }

    const key = `magic-typer-${this.el.id}`
    if (!localStorage.getItem(key)) {
      localStorage.setItem(key, true)
      if (this.el.dataset.expires) {
        let expires = new Date(this.el.dataset.expires)
        if (expires > new Date()) {
          element.innerHTML = '' // Clear the element's content
          setTimeout(typeCharacter, Math.random() * 1000)
        }
      } else {
        element.innerHTML = '' // Clear the element's content
        setTimeout(typeCharacter, Math.random() * 1000)
      }
    }
  },
}

function getSpeedConfig(speed) {
  if (speed === 'lightning-fast') {
    return { msBeforeNextCharacter: 1, min: 1, max: 2 }
  } else if (speed === 'slow') {
    return { msBeforeNextCharacter: 100, min: 1, max: 5 }
  } else {
    return { msBeforeNextCharacter: 40, min: 5, max: 20 }
  }

}
